export default {"src":"/_next/static/media/apple-appstore.a431a39b.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};